// 用户模块
export default {
  namespaced: true,
  state () {
    return {
      // 用户信息
      profile: {
        isLogin: false,
        userId: '',
        phone: '',
        name: '',
        token: '',
        passwd: '',
        hospitalName: ''
      },
      qrCodeHospital: null,
      qrCodeHospitalId: null,
      openId: '',
      canShowMall: true,
      // 小程序环境参数
      miniProgramParams: {
        from: '',
        hospitalId: '',
        openid: ''
      }
    }
  },
  mutations: {
    // setToken
    setToken (state, payload) {
      state.profile.token = payload
      state.profile.isLogin = true
    },
    // 修改用户信息，payload就是用户信息对象
    setUser (state, payload) {
      state.profile = payload
    },
    logout (state) {
      state.profile.isLogin = false
    },
    setQrCodeHospital (state, payload) {
      state.qrCodeHospital = payload
    },
    setQrCodeHospitalId (state, payload) {
      state.qrCodeHospitalId = payload
    },
    getQrCodeHospital (state) {
      return state.qrCodeHospital
    },
    getQrCodeHospitalId (state) {
      return state.qrCodeHospitalId
    },
    setOpenId (state, payload) {
      state.openId = payload
    },
    setCanShowMall (state, payload) {
      state.canShowMall = payload
    },
    // 设置小程序环境参数
    setMiniProgramParams (state, payload) {
      state.miniProgramParams = payload
    },
    // 清除小程序环境参数
    clearMiniProgramParams (state) {
      state.miniProgramParams = {
        from: '',
        hospitalId: '',
        openid: ''
      }
    }
  }
}
// ————————————————
// 版权声明：本文为CSDN博主「run-Ameng」的原创文章，遵循CC 4.0 BY-SA版权协议，转载请附上原文出处链接及本声明。
// 原文链接：https://blog.csdn.net/m0_58861443/article/details/120247013
